/** @format */

import {PeriodsModel} from 'components/PeriodSelector/model';

import {ExtendedPlatformWithAll} from 'types';

import {CalcMethod} from 'components/PropertyWidget/model';

export const DTO_DATE_FORMAT = 'yyyy-MM-dd';
export const TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';

export const PERIODS: PeriodsModel[] = [
  {
    key: 'current',
    name: 'Текущий период',
  },
  {
    key: 'quarter',
    name: '3 месяца',
  },
  {
    key: 'month',
    name: 'Месяц',
  },
  {
    key: 'week',
    name: 'Неделя',
  },
];

export const EXCLUDED_EXTENDED_PLATFORMS: ExtendedPlatformWithAll[] = [
  'YANDEX_SEARCH',
  'YANDEX_NETWORK',
  'GOOGLE_SEARCH',
  'GOOGLE_NETWORK',
];

export const HUE_BUDGET = 260;
export const HUE_KPI = 140;
export const HUE_PROPERTIES = 180;
export const HUE_SENSOR_GRAY = 60;
export const HUE_SENSOR_RED = 20;
export const HUE_SENSOR_YELLOW = 40;
export const HUE_WEATHER = 210;
export const HUE_SEASONALITY = 300;
export const HUE_FUNDS = 110;

export const DEFAULT_CALC_METHOD: CalcMethod = 'day';

export const MAX_TOOLTIP_EXTRA_ROWS = 6;

export const MAX_FORECAST_SPREAD = 20;

export const BANNER_HIDE_KEY = 'dc-banner-hide';
